import { createAsyncThunk } from '@reduxjs/toolkit';

const onfetchCompanies = async (_, { extra: { http } }) => {
  try {
    const result = await http.get(
      '/search/circles/autocomplete?filter_name=company'
    );
    return result;
  } catch {}
};

const onfetchSkills = async (_, { extra: { http } }) => {
  try {
    const result = await http.get(
      '/search/circles/autocomplete_skills?filter_name=skills'
    );
    return result;
  } catch {}
};

const onfetchTags = async (_, { extra: { http } }) => {
  try {
    const result = await http.get(
      '/search/circles/autocomplete_tags?filter_name=tags'
    );
    return result;
  } catch {}
};

const onFetchTalentPools = async (_, { extra: { http } }) => {
  try {
    const result = await http.get('/talent_pools/search?query=');
    return result;
  } catch {}
};

const onFetchClientCompanys = async (_, { extra: { http } }) => {
  try {
    const result = await http.get('/project_clients/search?query=');
    return result;
  } catch {}
};

export const fetchCompanies = createAsyncThunk(
  'fetch/filter/companies',
  onfetchCompanies,
  {
    condition: (_userId, { getState }) => {
      const { filters } = getState();
      return filters?.companies?.length === 0;
    },
  }
);

export const fetchSkills = createAsyncThunk(
  'fetch/filter/skills',
  onfetchSkills,
  {
    condition: (_userId, { getState }) => {
      const { filters } = getState();
      return filters?.skills?.length === 0;
    },
  }
);

export const fetchTalentPools = createAsyncThunk(
  'fetch/filter/talentPools',
  onFetchTalentPools,
  {
    condition: (_userId, { getState }) => {
      const { filters } = getState();
      return filters?.talentPools?.length === 0;
    },
  }
);

export const fetchClientCompanys = createAsyncThunk(
  'fetch/filter/clientCompanys',
  onFetchClientCompanys,
  {
    condition: (_userId, { getState }) => {
      const { filters } = getState();
      return filters?.clientCompanys?.length === 0;
    },
  }
);

const onOutreachTags = async (_, { extra: { http } }) => {
  try {
    const result = await http.get('/search/taggings/outreach');
    return result;
  } catch {}
};

const onFetchTemplateTags = async (_, { extra: { http } }) => {
  try {
    const result = await http.get('/search/taggings/template');
    return result;
  } catch {}
};

export const fetchTags = createAsyncThunk('fetch/filter/tags', onfetchTags, {
  condition: (_userId, { getState }) => {
    const { filters } = getState();
    return filters?.tags?.length === 0;
  },
});

export const fetchOutreachTags = createAsyncThunk(
  'fetch/outreach/tags',
  onOutreachTags,
  {
    condition: (_userId, { getState }) => {
      const { filters } = getState();
      return filters?.outreachTags?.length === 0;
    },
  }
);

export const fetchTemplateTags = createAsyncThunk(
  'fetch/template/tags',
  onFetchTemplateTags,
  {
    condition: (_userId, { getState }) => {
      const { filters } = getState();
      return filters?.templateTags?.length === 0;
    },
  }
);
